import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { segnaTappa } from "@/components/VisitaOspite";
import { API } from "@/lib/api";

/**
 * Quel che si vede inquadrando l'etichetta sullo scaffale, senza collegarsi.
 * Solo descrizione, categoria e unita': serve a capire cosa c'e' nel
 * contenitore. Giacenza e prezzo restano dentro l'app - l'etichetta e'
 * attaccata a uno scaffale che vede chiunque entri in magazzino.
 *
 * In fondo c'e' la scorciatoia per chi non sta solo guardando: porta al
 * prelievo con l'articolo gia' in lista. Chi non ha l'accesso trova il login,
 * e dopo averlo fatto ritorna qui, su questo stesso articolo.
 */
export default function MaterialePubblico() {
  const { id } = useParams();

  // Se a leggere questo QR e' un ospite in visita, la tappa entra nel suo
  // giro. Per tutti gli altri non succede niente.
  useEffect(() => { segnaTappa("materiale", id); }, [id]);
  const [dati, setDati] = useState(null);
  const [errore, setErrore] = useState(false);

  useEffect(() => {
    fetch(`${API}/public/materials/${id}`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(setDati)
      .catch(() => setErrore(true));
  }, [id]);

  if (errore) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">
      Articolo non trovato
    </div>;
  }
  if (!dati) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">
      Caricamento...
    </div>;
  }

  const m = dati.materiale;
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6"
         data-testid="materiale-pubblico">
      <div className="bg-white border border-slate-200 rounded-2xl p-8 max-w-md w-full text-center">
        <img src="/assets/sgm-logo.svg" alt="SGM Impianti" className="h-12 mx-auto mb-6" />
        <div className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-2">
          Magazzino materiali
        </div>
        <h1 className="font-display text-2xl font-bold leading-tight">{m.name}</h1>
        <div className="mt-4 flex justify-center gap-2 flex-wrap">
          <span className="text-sm border border-slate-200 rounded-full px-3 py-1">
            {m.category}
          </span>
          <span className="text-sm border border-slate-200 rounded-full px-3 py-1">
            si conta al {m.unit}
          </span>
        </div>
        <Link to={`/movimenti-materiali?mat=${m.id}`} data-testid="vai-al-prelievo"
              className="mt-6 block w-full h-12 leading-[3rem] rounded-lg bg-orange-500 hover:bg-orange-600 text-white font-semibold">
          Preleva o carica
        </Link>

        <p className="text-xs text-slate-400 mt-6">{dati.company?.name}</p>
      </div>
    </div>
  );
}
